import React, {Component} from 'react';
import 'react-router/Router';
import logo from '../assets/logo.svg';

class Start extends Component {

    constructor(props) {
        super(props);
        this.state = {value: ''};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.history.push(`/app/${this.state.value}`);
    }

    render() {
        return (
            <main className="main start">
                <img src={logo} alt="THX Stream" className="app-logo img-fluid"/>

                <form onSubmit={this.handleSubmit}>
                    <label>
                        Enter tracking code:
                    </label>
                    <div className="form-group form-inline">
                        <input type="text" name="tracking_reference" className="form-control" placeholder="Enter your 6 digit unique code" maxLength={6} value={this.state.value} onChange={this.handleChange} />
                        <button className="btn">Go</button>
                    </div>
                </form>
            </main>
        );
    }
}

export default Start;



// WEBPACK FOOTER //
// ./src/components/Start.js